import { render, staticRenderFns } from "./Cv.vue?vue&type=template&id=4c25e4c0&scoped=true&"
import script from "./Cv.vue?vue&type=script&lang=js&"
export * from "./Cv.vue?vue&type=script&lang=js&"
import style0 from "./Cv.vue?vue&type=style&index=0&id=4c25e4c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c25e4c0",
  null
  
)

export default component.exports